import { AggregateByTypeRequest, CUSTOM_ATTRIBUTE_ROUTES } from "@zeal/common";
import { IAxiosInstance } from "../../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../../AbstractApiClient/IApiResponse";

export const aggregateByType = (axios: IAxiosInstance) => {
  return async (data: AggregateByTypeRequest) => {
    const response = await axios.noRetry.get<IApiResponse<any>>(
      `${CUSTOM_ATTRIBUTE_ROUTES.AGGREGATE_ATTRIBUTES.replace(
        ":type",
        data.type
      )}`,
      { params: { companyID: data.companyID } }
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
